<script>
import {Bar} from 'vue-chartjs'

export default {
  extends: Bar,
  data() {
    return {
      opportunity_data: {
        labels: ['Tender #1', 'Tender #2'],
        datasets: [{
          label: '# of Bid Bonds per Tender',
          backgroundColor: "rgba(255,99,132,0.2)",
          borderColor: "rgba(255,99,132,1)",
          data: [0, 0],
          borderWidth: 1
        }]
      },
      options: {
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            stacked: true,
            gridLines: {
              display: true,
              color: "rgba(255, 99, 132, 0.2)"
            }
          }],
          xAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    }
  },
  computed: {
    oppObj() {
      return this.$store.getters.getOpportunity;
    },
    opportunity() {
      return this.oppObj.group_count;
    },
  },
  watch: {
    opportunity() {
      this.displayGraph();
    }
  },
  mounted() {
    this.displayGraph();
  },
  methods: {
    displayGraph() {
      if (!this.opportunity.length) {
        this.opportunity_data.datasets[0]['data'] = [];
        this.opportunity_data.labels = [];
      }
      this.opportunity_data.datasets[0]['data'] = this.opportunity.map(k => k.count);
      this.opportunity_data.labels = this.opportunity.map(k => k.tender);
      this.renderChart(this.opportunity_data, this.options)
    }
  },
}
</script>
